import React__default from 'react';

const RightChevron = ({ className, style, isFlipped }) => (React__default.createElement("svg", { "aria-hidden": 'true', "data-rev-component": 'right-chevron-icon', className: className, style: { ...style, transform: isFlipped ? 'scaleX(-1)' : undefined }, xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    React__default.createElement("path", { d: 'm9 18 6-6-6-6' })));

export { RightChevron };
//# sourceMappingURL=RightChevron.js.map
